import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Hash = createReactComponent("Hash", ["svg", defaultAttributes, [["line", {
  x1: "4",
  y1: "9",
  x2: "20",
  y2: "9",
  key: "v4ep6u"
}], ["line", {
  x1: "4",
  y1: "15",
  x2: "20",
  y2: "15",
  key: "1id021"
}], ["line", {
  x1: "10",
  y1: "3",
  x2: "8",
  y2: "21",
  key: "1q2ln8"
}], ["line", {
  x1: "16",
  y1: "3",
  x2: "14",
  y2: "21",
  key: "10y5cg"
}]]]);
export default Hash;